<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋名稱" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

      <el-select v-model="filteringStatus" @change="search" placeholder="篩選狀態" style="width: 120px;margin-left: 10px;">
        <el-option label="全部" value="全部"/>
        <el-option label="已發佈" value="已發佈"/>
        <el-option label="下架" value="下架"/>
      </el-select>

    </template>
    <template slot="right">
      <el-button @click="showEmbedModal">嵌入</el-button>
      <el-tooltip v-if="$store.getters.adminMissValidFBPageAccessToken" effect="dark" content="請先刷新FB登入" placement="bottom">
        <span>
          <el-button :disabled="true" @click="sync" style="margin-right: 20px;">同步</el-button>
        </span>
      </el-tooltip>
      <el-button v-else @click="sync" style="margin-right: 20px;">同步</el-button>
      <el-button v-if="$store.getters.adminMissValidFBPageAccessToken" @click="authFB">刷新FB驗證</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">

      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="預覽" width="120px" align="center">
          <template slot-scope="scope">
            <img
              v-if="getPostImg(scope.row)"
              :src="getPostImg(scope.row)"
              class="fb-img-preview"/>
          </template>
        </el-table-column>
        <el-table-column label="內容" min-width="120px">
          <template slot-scope="scope">
            {{getPostTxt(scope.row)}}
            <br v-if="scope.row.isJustUpdated || scope.row.isJustCreated">
            <el-tag v-if="scope.row.isJustUpdated" type="success">已更新</el-tag>
            <el-tag v-if="scope.row.isJustCreated" type="primary">新增</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="FB發佈時間" width="160px">
          <template slot-scope="scope">
            {{scope.row.Data.CreatedTime | moment}}
          </template>
        </el-table-column>
        <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column>
        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsActive" class="deployed">發佈</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button
              class="left"
              size="mini"
              round
              @click="previewPost(scope.row)">預覽</el-button>
            <el-button
              v-if="!scope.row.IsActive"
              type="success"
              size="mini"
              round
              @click="activate(scope.row)">發佈</el-button>
            <el-button
              v-else
              type="warning"
              size="mini"
              round
              @click="inactivate(scope.row)">下架</el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

      <f-b-post-preview-modal :isShow="isShowPreviewModal" @close="isShowPreviewModal = false" :previewing-post-i-d="previewingPostID" :fans-page-i-d="fansPageID" :fans-page-num-i-d="fansPageNumID"/>
      <f-b-post-embed-modal :isShow="isShowEmbedModal" @close="isShowEmbedModal = false" :fans-page-i-d="fansPageID" :fans-page-num-i-d="fansPageNumID" @submit="embed"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
import FBPostPreviewModal from './preview-modal.vue'
import FBPostEmbedModal from './embed-modal.vue'
import config from '@/assets/js/config'
import MixinAuthFB from '@/utils/fb/mixin-auth.vue'
// mixin
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinFilters, MixinDelaySearch, MixinAuthFB],
  components: {
    LeftMenu,
    TopHeader,
    FBPostPreviewModal,
    FBPostEmbedModal
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null,
      // fb 嵌入
      isShowEmbedModal: false,
      // fb 預覽
      isShowPreviewModal: false,
      previewingPostID: null,
      fansPageID: config.FBFansPageID,
      fansPageNumID: config.FBFansPageNumID
    }
  },
  computed: {},
  methods: {
    embed (data) {
      let postID = data.id
      let datetime = moment(data.dt).format()
      let id = `${this.fansPageID}_${postID}`
      let idx = this.$store.state.fbGrabedPost.list.findIndex(o => String(o.DataId) === String(id))
      if (idx >= 0) {
        alert('此貼文早已在系統同步了!')
        return
      }

      let payload = {
        id: id,
        dt: datetime
      }

      this.$services.fbGrabedPost.embed(this, payload).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          this.$store.state.fbGrabedPost.list.splice(0, 0, res.data.result)
          this.currentPage = 1
          this.search()
          this.$message({
            message: `成功嵌入`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    showEmbedModal () {
      this.isShowEmbedModal = true
    },
    activate (post) {
      this.$services.fbGrabedPost.activate(this, post.ID).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.fbGrabedPost.list.findIndex(o => o.ID === post.ID)
          if (idx >= 0) {
            this.$set(this.$store.state.fbGrabedPost.list[idx], 'IsActive', true)
          }
          this.filterObjs()
          this.tableData = this.searchedObjs.slice((this.currentPage - 1) * 20, this.currentPage * 20)
          this.$message({
            message: `成功發佈`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    inactivate (post) {
      this.$services.fbGrabedPost.inactivate(this, post.ID).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.fbGrabedPost.list.findIndex(o => o.ID === post.ID)
          if (idx >= 0) {
            this.$set(this.$store.state.fbGrabedPost.list[idx], 'IsActive', false)
          }
          this.filterObjs()
          this.tableData = this.searchedObjs.slice((this.currentPage - 1) * 20, this.currentPage * 20)
          this.$message({
            message: `成功下架`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    getPostImg (post) {
      if (post.Data.Attachments && post.Data.Attachments.Data && post.Data.Attachments.Data.length) {
        for (var i = 0; i < post.Data.Attachments.Data.length; ++i) {
          let FBPostAttachmentData = post.Data.Attachments.Data[i]
          if (FBPostAttachmentData.Media && FBPostAttachmentData.Media.Image && FBPostAttachmentData.Media.Image.Src) { return FBPostAttachmentData.Media && FBPostAttachmentData.Media.Image && FBPostAttachmentData.Media.Image.Src }
          if (FBPostAttachmentData.Subattachments && FBPostAttachmentData.Subattachments.Data && FBPostAttachmentData.Subattachments.Data.length) {
            for (var j = 0; j < FBPostAttachmentData.Subattachments.Data.length; ++j) {
              let FBPostSubAttachmentData = FBPostAttachmentData.Subattachments.Data[i]
              if (FBPostSubAttachmentData.Media && FBPostSubAttachmentData.Media.Image && FBPostSubAttachmentData.Media.Image.Src) { return FBPostSubAttachmentData.Media && FBPostSubAttachmentData.Media.Image && FBPostSubAttachmentData.Media.Image.Src }
            }
          }
        }
      }
      return false
    },
    getPostTxt (post) {
      if (post.IsEmbed) return '(嵌入)'
      if (post.Data.Message) return post.Data.Message
      if (post.Data.Story) return post.Data.Story

      if (post.Data.Attachments && post.Data.Attachments.Data && post.Data.Attachments.Data.length) {
        for (var i = 0; i < post.Data.Attachments.Data.length; ++i) {
          let FBPostAttachmentData = post.Data.Attachments.Data[i]
          if (FBPostAttachmentData.Description) return FBPostAttachmentData.Description
          if (FBPostAttachmentData.Title) return FBPostAttachmentData.Title
        }
      }
      return '-'
    },
    previewPost (post) {
      this.isShowPreviewModal = true
      this.previewingPostID = post.DataId.split('_')[1]
    },
    sync () {
      if (this.$store.getters.adminMissValidFBAccessToken) {
        if (!window.confirm('請先登入FB!')) return
        return this.authFB().then(this.sync).catch(console.error)
      }

      this.$services.fbGrabedPost.sync(this).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let result = res.data.result
          this.$notify({ message: `成功抓取粉絲專頁${result.Fetched}筆貼文，新增${result.New}筆新貼文至系統，更新${result.Updated}筆舊貼文`, duration: 0 })
          this.$store.state.fbGrabedPost.isFetched = false
          this.loadData()
        }
      }).catch(this.$handleServiceError)
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.fbGrabedPost.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        let isTitleFit = o.Title && o.Title.includes(this.keyword)
        return isTitleFit
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.$store.state.fbGrabedPost.list.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.Tw.Title}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.post.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.fbGrabedPost.list.findIndex(o => o.ID === obj.ID)
          if (idx >= 0) this.$store.state.fbGrabedPost.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    loadData () {
      const initTableData = () => {
        this.searchedObjs = this.$store.state.fbGrabedPost.list
        this.tableData = this.searchedObjs.slice(0, 20)
      }
      if (
        !this.$store.state.fbGrabedPost.isFetched &&
        !this.$store.state.fbGrabedPost.isFetching
      ) {
        this.$services.fetchFBGrabedPostDatas(this).then(initTableData).catch(this.$handleServiceError)
      } else {
        initTableData()
      }
    }
  },
  created () {
    this.loadData()
  }
}
</script>

<style>
.fb-img-preview {
  max-width: 100%;
  max-height: 80px;
}
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
